import { useCallback } from "react";

import { FeedbackType } from "../../../../API";
import { UpdateEventFeedbackInput } from "../../../../common/types/events/api";
import { EventViewModel } from "../../models/eventViewModel";
import FeedbackThumbs from "./FeedbackThumbs";

interface FeedbackThumbsTableCellContainerProps {
  event: EventViewModel;
  onUpdateEventFeedback: (
    input: UpdateEventFeedbackInput,
    event: EventViewModel
  ) => Promise<void>;
}

const FeedbackThumbsTableCellContainer = ({
  event,
  onUpdateEventFeedback,
}: FeedbackThumbsTableCellContainerProps) => {
  const memoizedThumbUpClick = useCallback(async () => {
    if (event.feedback === FeedbackType.POSITIVE) {
      return;
    }

    const input: UpdateEventFeedbackInput = {
      pk: event.customerId,
      sk: event.id,
      feedback: FeedbackType.POSITIVE,
      mitigatedRisk: null,
    };

    await onUpdateEventFeedback(input, event);
  }, [event]);

  const memoizedThumbsDownClickCallback = useCallback(async () => {
    if (event.feedback === FeedbackType.NEGATIVE) {
      return;
    }

    const input: UpdateEventFeedbackInput = {
      pk: event.customerId,
      sk: event.id,
      feedback: FeedbackType.NEGATIVE,
      mitigatedRisk: null,
    };

    await onUpdateEventFeedback(input, event);
  }, [event]);

  return (
    <FeedbackThumbs
      timestamp={event.timestamp}
      feedback={event.feedback}
      mitigatedRisk={event.mitigatedRisk}
      onThumbUpClick={memoizedThumbUpClick}
      onThumbsDownClick={memoizedThumbsDownClickCallback}
    />
  );
};

export default FeedbackThumbsTableCellContainer;
